<template>
	<div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="icon-lx-calendar"></i> 系统管理</el-breadcrumb-item>
				<el-breadcrumb-item>角色管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<div class="handle-box left">
				<el-input v-model="data.filterstr" size="large" placeholder="筛选关键词(角色名称/英文名称)" class="handle-input mr10"></el-input>
				<el-button type="primary" icon="search" @click="search" v-if="power.search">搜索</el-button>
			</div>
			<div class="handle-box right">
				<el-button type="primary" @click="toAdd" class="mr10" v-if="power.add">
					<i class="icon-lx-roundadd"></i>新增角色
				</el-button>
				<el-button type="primary" @click="toRight" :disabled="data.selections.length!=1" class="mr10"
					v-if="power.allotRight">
					<i class="icon-lx-roundadd"></i>分配权限
				</el-button>
				<el-button type="danger" @click="toDelete" :disabled="data.selections.length==0" class="mr10"
					v-if="power.delete">
					<i class="el-icon-delete"></i>删除角色
				</el-button>
			</div>
			<el-table ref="roletable" :data="data.rows" border class="table" row-key="roleid"
				@selection-change="handleSelectionChange" @cell-click="handleCellClick">
				<el-table-column type="selection" width="40" :selectable="enableSelection">
				</el-table-column>
				<el-table-column prop="name" label="角色名称" width="120" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="crTime" label="创建时间" width="260">
				</el-table-column>
				<el-table-column prop="crUserName" label="创建人" width="100">
				</el-table-column>
				<el-table-column prop="modTime" label="修改时间" width="260">
				</el-table-column>
				<el-table-column prop="modUserName" label="修改人" width="100">
				</el-table-column>
				<el-table-column prop="enable" label="有效" width="100">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.enable">有效</el-tag>
						<el-tag type="danger" v-else>无效</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="角色描述" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="opt" label="操作" width="380" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit" @click="toEdit(scope.row)"
							v-if="power.edit">修改
						</el-button>
						<el-button size="mini" type="danger" icon="el-icon-edit" @click="doEnable(scope.row.id,false)"
							v-if="power.disable && scope.row.enable">停用
						</el-button>
						<el-button size="mini" type="primary" icon="el-icon-edit" @click="doEnable(scope.row.id,true)"
							v-if="power.enable && !scope.row.enable">启用
						</el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete" @click="toDelete([scope.row])"
							v-if="power.delete">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
					:current-page="data.page" :page-sizes="[10,20,50,100,200,300,400,500]" :page-size="data.size"
					layout="total, sizes, prev, pager, next, jumper" :total="data.total">
				</el-pagination>
			</div>
		</div>

		<!-- 新增/编辑弹出框 -->
		<el-dialog :title="data.info.type" :visible.sync="data.editVisible" width="500px" :close-on-click-modal="false">
			<el-form ref="infoDialog" :model="data.info" label-width="130px">
				<el-form-item label="角色名称:">
					<el-input v-model="data.info.name" size="large"></el-input>
				</el-form-item>
				<el-form-item label="是否有效:">
					<el-switch v-model="data.info.enable" active-color="green" inactive-color="gray">
					</el-switch>
				</el-form-item>
				<el-form-item label="角色描述:">
					<el-input v-model="data.info.remark" type="textarea" size="large"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveInfo">确 定</el-button>
				<el-button @click="clearAndCloseInfo">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 删除提示框 -->
		<el-dialog title="提示" :visible.sync="data.delVisible" width="300px" center>
			<div class="del-dialog-cnt" :close-on-click-modal="false">
				正在删除角色:
				<template v-for="item in data.rowsToDelete">
					{{ item.name }}、
				</template>
				删除不可恢复，是否确定删除？
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="deleteRow">确 定</el-button>
				<el-button @click="data.delVisible = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 授权窗口 -->
		<el-dialog :title="data.selections.length==0?'':('功能授权 - '+data.selections[0].name)"
			:visible.sync="data.authorizeVisible" :close-on-click-modal="false" width="800px">
			<el-tree id="rm_rights" ref="rm_rights" :data="data.rights" node-key="id" default-expand-all show-checkbox
				:default-checked-keys="data.checkedRights" :auto-expand-parent="false" check-on-click-node
				:expand-on-click-node="false">
				<span slot-scope="{ node, data }">
					<span :class="data.level!=4?'':'last'">{{ data.title }}</span>
				</span>
			</el-tree>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveAuthorize">确 定</el-button>
				<el-button @click="data.authorizeVisible = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'rolemanage',
		data() {
			return {
				visible: {
					loading: false
				},
				data: {
					filterstr: '',
					total: 0,
					size: 10,
					page: 1,
					rows: [],
					selections: [],
					editVisible: false,
					rowsToDelete: [],
					delVisible: false,
					info: {
						type: 'add',
						id: 0,
						name: '',
						enable: true,
						remark: ''
					},
					authorizeLoaded: true,
					authorizeVisible: false,
					checkedRights: [],
					rights: []
				},
				power: {
					pageId: 4,
					search: false,
					add: false,
					edit: false,
					allotRight: false,
					delete: false,
					enable: false,
					disable: false
				}
			}
		},
		methods: {
			enableSelection(r, idx) {
				return true;//r.id != 1;
			},
			search(change) {
				let vue = this;
				vue.loading = false;
				if (change) {
					vue.data.page = 1;
				}
				window.ax.get('api/system/role/list?pagesize=' + vue.data.size +
					'&currentpage=' + vue.data.page + '&sign=' + window.$gloable.userinfo.sign + '&filterStr=' + vue.data.filterstr, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						vue.data.rows = data.datas;
						vue.data.total = total;
						if (len == 0 && total > 0) {
							vue.data.page = Math.ceil(total / vue.data.size);
							vue.search();
						}
					} else {
						vue.$message.error(data.message);
					}
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
			loadRight() {
				let vue = this;
				vue.data.authorizeVisible = true;
				vue.data.rights = [];
				vue.data.checkedRights = [];
				vue.visible.loading = true;
				let id = 0;
				if (vue.data.selections.length > 0) {
					id = vue.data.selections[0].id;
					window.ax.get('api/system/roleright?sign=' + window.$gloable.userinfo.sign + '&id=' + id).then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							vue.data.rights = data.data.rights;
							vue.data.checkedRights = data.data.curRights;
							setTimeout(() => {
								var element = document.getElementById('rm_rights');
								if (element) {
									var elements = element.getElementsByClassName('last');
									var len = elements.length;
									for (var i = 0; i < len; i++) {
										let pe1 = elements[i].parentElement.parentElement;
										pe1.style = 'padding-left:0';
										let pe2 = pe1.parentElement;
										pe2.style = 'display:inline-block;width:200px;float:left';
										let pe3 = pe2.parentElement;
										pe3.style = 'padding-left:52px';
									}
								}
							}, 500);
						} else {
							vue.$message.error(data.message);
						}
						vue.visible.loading = false;
					}).catch(err => {
						vue.$message.error('执行脚本出错，请联系管理员');
						vue.visible.loading = false;
					});
				} else {
					vue.$message.error('请选择需要授权的角色');
				}
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.search(true);
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			toAdd() {
				this.data.info.type = '新增';
				this.data.info.id = 0;
				this.data.info.status = true;
				this.data.info.name = '';
				this.data.info.remark = '';
				this.data.editVisible = true;
			},
			toEdit(row) {
				let vue = this;
				vue.visible.loading = true;
				window.ax.get('api/system/role/info?sign=' + window.$gloable.userinfo.sign + '&id=' + row.id, {}).then(
					rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							vue.data.info = data.data;
							vue.data.info.type = '修改 - ' + row.name;
							vue.data.editVisible = true;
						} else {
							vue.$message.error(data.Message);
						}
						vue.visible.loading = false;
					}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
			toRight() {
				this.loadRight();
			},
			toDelete(row) {
				if (Array.isArray(row)) {
					this.data.rowsToDelete = row;
				} else {
					this.data.rowsToDelete = this.data.selections;
				}
				this.data.delVisible = true;
			},
			saveAuthorize() {
				let vue = this;
				vue.visible.loading = true;
				let ids = '';
				let arr1 = vue.$refs.rm_rights.getCheckedKeys();
				let arr2 = vue.$refs.rm_rights.getHalfCheckedKeys();
				let len = arr1.length;
				if (len > 0) {
					for (var i = 0; i < len; i++) {
						ids += (arr1[i] + ',');
					}
				}
				len = arr2.length;
				if (len > 0) {
					for (var i = 0; i < len; i++) {
						ids += (arr2[i] + ',');
					}
				}
				if (ids.length > 0) {
					ids = ids.substring(0, ids.length - 1);
				}
				let id = vue.data.selections[0].id;
				window.ax.post('api/system/roleright', {
					Sign: window.$gloable.userinfo.sign,
					id: id,
					RightIds: ids
				}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						vue.$message.success('保存成功');
					} else {
						vue.$message.error(data.Message);
					}
					vue.data.authorizeVisible = false;
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
			saveInfo() {
				let vue = this;
				vue.visible.loading = true;
				var inf = this.data.info;
				window.ax.post('api/system/role/save', {
					Sign: window.$gloable.userinfo.sign,
					Id: inf.id,
					Name: inf.name,
					Enable: inf.enable,
					Remark: inf.remark,
					ChangeFlag: 0
				}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						vue.search();
						vue.clearAndCloseInfo();
						vue.$message.success('保存成功');
					} else {
						vue.$message.error(data.Message);
					}
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
			clearAndCloseInfo() {
				this.data.editVisible = false;
				this.data.info.id = 0;
				this.data.info.status = true;
				this.data.info.name = '';
				this.data.info.remark = '';
			},
			deleteRow() {
				let vue = this;
				vue.visible.loading = true;
				let len = vue.data.rowsToDelete.length;
				if (len > 0) {
					let ids = [];
					for (var i = 0; i < len; i++) {
						var r = vue.data.rowsToDelete[i];
						ids.push(r.id);
					}
					window.ax.post('api/system/role/delete', {
						Sign: window.$gloable.userinfo.sign,
						ids: ids
					}).then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							vue.search();
							vue.$message.success('删除成功');
						} else {
							vue.$message.error(data.message);
						}
						vue.data.delVisible = false;
						vue.visible.loading = false;
					}).catch(err => {
						vue.$message.error('执行脚本出错，请联系管理员');
						vue.visible.loading = false;
					});
				}
			},
			doEnable(id, status) {
				let vue = this;
				vue.visible.loading = true;
				window.ax.post('api/system/role/save', {
					Sign: window.$gloable.userinfo.sign,
					Id: id,
					ChangeFlag: status ? 2 : 1
				}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						vue.search();
						vue.clearAndCloseInfo();
						vue.$message.success((status ? '停用' : '启用') + '成功');
					} else {
						vue.$message.error(data.Message);
					}
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
			handleSelectionChange(selections) {
				this.data.selections = selections;
			},
			handleCellClick(row, column, cell, event) {
				if (column.property != 'opt') {
					this.$refs.roletable.toggleRowSelection(row, this.data.selections.indexOf(row) == -1);
				}
			}
		},
		created() {
			this.baseJS.initPower(this.power);
			this.search();
		},
		mounted() {}
	}
</script>

<style scoped>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}
</style>
